'use strict';
import * as $j_app$002eapi$002e$002dUnauthenticated$002dApp$002dUpdate$0024$002dApp$002dUpdate$002dInfo from "./app.api.-Unauthenticated-App-Update$-App-Update-Info.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$() {
}
export { $c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$ as $c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$ };
$c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$.prototype.constructor = $c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$;
/** @constructor */
function $h_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$() {
}
export { $h_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$ as $h_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$ };
$h_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$.prototype = $c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$.prototype;
$c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$.prototype.toString__T = (function() {
  return "AppUpdateInfo";
});
$c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$.prototype.fromProduct__s_Product__Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo = (function(x$0) {
  var ev$12 = x$0.productElement__I__O(0);
  var buildTime$1 = ((ev$12 === null) ? null : ev$12.Lframework_data_FrameworkDateTime__f_ldt);
  return new $j_app$002eapi$002e$002dUnauthenticated$002dApp$002dUpdate$0024$002dApp$002dUpdate$002dInfo.$c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo(buildTime$1);
});
$c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo(p);
});
var $d_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$, "app.api.UnauthenticatedAppUpdate$AppUpdateInfo$", ({
  Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$ as $d_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$ };
var $n_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$;
function $m_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$() {
  if ((!$n_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$)) {
    $n_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$ = new $c_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$();
  }
  return $n_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$;
}
export { $m_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$ as $m_Lapp_api_UnauthenticatedAppUpdate$AppUpdateInfo$ };
//# sourceMappingURL=app.api.-Unauthenticated-App-Update$-App-Update-Info$.js.map
